export const PERGUNTA_MOTIVO_CANCELAMENTO = 'Selecione o motivo de cancelamento'

export const PERGUNTA_SUBMOTIVO = 'Poderia nos explicar melhor?'

export const CODIGO_DEFAULT_SUBMOTIVO = 'DEFAULT_SUBMOTIVO'

export const CODIGO_DEFAULT_MOTIVO = 'DEFAULT'

export const MENSAGEM_SATISFACAO_NAO_PREENCHIDA = 'Selecione nível de satisfação!'

export const LISTA_OPCOES = [
  {
    'valor': 'Sim'
  },
  {
    'valor': 'Não'
  }
]

export const deixaPrimeiraLetraStringMaiusculo = string => string.charAt( 0 ).toUpperCase() + string.slice( 1 )

export const perguntaDisponibilidadeVolta = modalidade => {
  const tituloModalidade = deixaPrimeiraLetraStringMaiusculo( modalidade )
  return `Você estaria disposto a voltar na TAG ${tituloModalidade}?`
}


export const perguntaQuantidadeLivrosLidos = modalidade => {
  const tituloModalidade = deixaPrimeiraLetraStringMaiusculo( modalidade )
  return `Quantos livros enviados pela TAG ${tituloModalidade} você leu?`
}
